import { Switch, Tooltip } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/colors";

interface ToggleProps {
  onChange: any;
  initialCheck: boolean;
  disabled?: boolean;
  index?: number;
  data?: any;
  tooltip?: any;
}

const BaseToggle = ({
  onChange,
  initialCheck,
  disabled,
  index,
  data,
  tooltip
}: ToggleProps) => {
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (initialCheck) {
      setChecked(initialCheck);
    }
  }, [initialCheck]);

  const handleToggle = (event: any) => {
    onChange(!checked, index || null, data);
    setChecked(!checked);
  };

  return (
      <Tooltip title={tooltip} placement="bottom">
        <Switch
        disabled={disabled}
        onChange={handleToggle}
        checked={checked}
        style={{
          backgroundColor: checked ? colors.success : colors.border,
        }}
      />
      </Tooltip>
    )
};

export default BaseToggle;
